<template>
  <v-bottom-sheet persistent scrollable v-model="opened" width="500" content-class="bottom-sheet-centered">
    <template #activator="{ props }">
     <div
      class="filter-bottom-btn"
      :class="fixedBottom ? 'fixed-bottom' : ''"
      v-touch="{
        up: () => opened = true
      }">
        <v-btn
          v-bind="props"
          class="v-btn--filter"
          elevation="2"
        ><v-icon start color="grey">mdi-filter</v-icon> Filter</v-btn>
      </div>
    </template>
    <component v-if="component" :is="component" @close="opened = false" />
  </v-bottom-sheet>
</template>

<script lang="ts">
import {computed, defineComponent, getCurrentInstance, ref} from 'vue';

export default defineComponent({
  name: 'FilterBtn',
  props: {
    fixedBottom: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const instance = getCurrentInstance();
    const opened = ref(false);
    return {
      opened,
      component: computed(() => instance?.proxy?.$route?.meta?.filter),
    };
  },
});
</script>

<style scoped>
.filter-bottom-btn{
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
}
.v-btn--filter {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  padding-bottom: var(--inset-bottom) !important;
  height: calc(36px + var(--inset-bottom)) !important;
}

</style>

<style>
.bottom-sheet-centered {
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
